import React from 'react';

const TABS = [
  { key: 'all', label: 'Svi', color: 'gray' },
  { key: 'open', label: 'Novi', color: 'blue' },
  { key: 'in_mediation', label: 'U medijaciji', color: 'yellow' },
  { key: 'resolved', label: 'Rešeni', color: 'green' },
  { key: 'escalated', label: 'Eskalovani', color: 'red' },
];

const colorMap = {
  gray: 'bg-gray-100 text-gray-700 border-gray-300',
  blue: 'bg-blue-100 text-blue-700 border-blue-300',
  yellow: 'bg-amber-100 text-amber-700 border-amber-300',
  green: 'bg-emerald-100 text-emerald-700 border-emerald-300',
  red: 'bg-red-100 text-red-700 border-red-300',
};

const activeColorMap = {
  gray: 'bg-gray-700 text-white border-gray-700',
  blue: 'bg-blue-600 text-white border-blue-600',
  yellow: 'bg-amber-500 text-white border-amber-500',
  green: 'bg-emerald-600 text-white border-emerald-600',
  red: 'bg-red-600 text-white border-red-600',
};

const DisputeStatusTabs = ({ activeTab, onTabChange, counts = {} }) => {
  return (
    <div className="flex flex-wrap gap-2 mb-6">
      {TABS?.map((tab) => {
        const isActive = activeTab === tab?.key;
        const count = counts?.[tab?.key] ?? 0;
        const colorClass = isActive ? activeColorMap?.[tab?.color] : colorMap?.[tab?.color];
        return (
          <button
            key={tab?.key}
            onClick={() => onTabChange(tab?.key)}
            className={`flex items-center gap-2 px-4 py-2 rounded-lg border font-medium text-sm transition-all duration-200 ${
              isActive ? colorClass + ' shadow-md' : colorClass + ' hover:opacity-80'
            }`}
          >
            {tab?.label}
            <span className={`inline-flex items-center justify-center w-5 h-5 rounded-full text-xs font-bold ${
              isActive ? 'bg-white/20' : 'bg-white/60'
            }`}>
              {count}
            </span>
          </button>
        );
      })}
    </div>
  );
};

export default DisputeStatusTabs;
